import { render, staticRenderFns } from "./portal_reviews_filter.vue?vue&type=template&id=2beeb853&"
import script from "./portal_reviews_filter.vue?vue&type=script&lang=js&"
export * from "./portal_reviews_filter.vue?vue&type=script&lang=js&"
import style0 from "./portal_reviews_filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../static/blizko/local/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports